module.exports = __webpack_public_path__ + "img/9-BR7.9fee952.jpg";